import { mapGetters } from 'vuex';

export default {
    name: 'guideAuthorInfo',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide'])
    }
};
